import client1 from "../../assets/client1.webp";
import client2 from "../../assets/client2.webp";
import client3 from "../../assets/client3.webp";
import client4 from "../../assets/client4.webp";
import client5 from "../../assets/client5.webp";
import client6 from "../../assets/client6.webp";

const testimonialsData = [
  {
    id: 1,
    img: client4,
    alt: "Motivated man working out at the gym.",
    name: "James Anderson",
    review:
      "The atmosphere in this gym is unmatched. Skilled trainers, high-quality equipment, and a welcoming community have helped me exceed my fitness goals.",
  },
  {
    id: 2,
    img: client1,
    alt: "Motivated woman working out at the gym.",
    name: "Sophia Martinez",
    review:
      "Joining this gym has been life-changing. The trainers are incredibly supportive, and the environment is perfect for achieving results.",
  },
  {
    id: 3,
    img: client5,
    alt: "Focused man working out at the gym.",
    name: "Liam Scott",
    review:
      "This gym provides a transformative experience. With tailored guidance and a motivational setting, I've reached milestones I never thought possible.",
  },
  {
    id: 4,
    img: client3,
    alt: "Focused woman working out at the gym.",
    name: "Olivia Wilson",
    review:
      "The dedication of the team here is unparalleled. The community and expertise have helped me become stronger both mentally and physically.",
  },
  {
    id: 5,
    img: client2,
    alt: "Determined woman working out at the gym.",
    name: "Ava Thompson",
    review:
      "This is more than a gym; it's a place where determination and support come together. I’ve found the motivation and tools to thrive in my fitness journey.",
  },
  {
    id: 6,
    img: client6,
    alt: "Determined man working out at the gym.",
    name: "Noah Brown",
    review:
      "This gym has exceeded my expectations. The staff’s guidance and the supportive atmosphere have made every workout an enjoyable challenge.",
  },
];

export default testimonialsData;
